<div class="bg-surface-50 dark:bg-surface-900 shadow-lg">
  <div class="px-4 flex justify-between relative md:static h-16 max-w-screen-xl mx-auto">
    <!-- Logo and Dashboard Link -->
    <div class="flex flex-row items-center md:mr-8 cursor-pointer" routerLink="/">
      <img alt="{{ businessName }}" class="h-10 object-contain" height="34" ngSrc="logo/long-logo.png" width="160" />
    </div>

    <!-- Mobile Menu Toggle -->
    <button class="md:hidden cursor-pointer block lg:hidden text-700 cursor-pointer" type="button" (click)="toggleSidebar()">
      <i class="pi pi-bars text-2xl"></i>
    </button>

    <!-- Navigation and User Section -->
    <div
      class="flex-1 justify-between hidden md:flex absolute md:static md:w-auto w-full left-0 top-16 z-10 shadow-lg md:shadow-none bg-surface-50 dark:bg-surface-900 border-y md:border-none border-gray-200 dark:border-gray-700"
      [class.hidden]="!isSidebarOpen()"
      (clickOutside)="closeSidebar()">
      <!-- Navigation Links -->
      <ul class="list-none p-0 m-0 flex flex-col md:flex-row select-none border-b md:border-none border-gray-200 dark:border-gray-700">
        @for (item of menuItems; track item.fragment) {
          <li>
            <a
              class="flex gap-4 px-6 py-3 h-full md:py-2 items-center text-gray-600 dark:text-gray-300 border-l-2 md:border-b-2 md:border-l-0 border-transparent hover:border-primary-500 font-semibold cursor-pointer transition-colors duration-150"
              routerLink="/"
              [fragment]="item.fragment"
              (click)="closeSidebar()">
              <i class="block md:!hidden" [class]="item.icon"></i>
              <span>{{ item.label }}</span>
            </a>
          </li>
        }
      </ul>

      <ul
        class="list-none p-0 m-0 flex flex-col md:flex-row select-none border-b md:border-none border-gray-200 dark:border-gray-700 block md:hidden">
        @if (user$ | async; as user) {
          <li>
            <a
              class="flex gap-4 px-6 py-3 h-full md:py-2 items-center text-gray-600 dark:text-gray-300 border-l-2 md:border-b-2 md:border-l-0 border-transparent hover:border-primary-500 font-semibold cursor-pointer transition-colors duration-150"
              routerLink="/dashboard"
              routerLinkActive="!border-primary-500"
              [routerLinkActiveOptions]="{ exact: true }"
              (click)="closeSidebar()">
              <i class="pi pi-home"></i>
              <span>Dashboard</span>
            </a>
          </li>
          @for (item of userMenuItems; track item.routerLink) {
            <li>
              <a
                class="flex gap-4 px-6 py-3 h-full md:py-2 items-center text-gray-600 dark:text-gray-300 border-l-2 md:border-b-2 md:border-l-0 border-transparent hover:border-primary-500 font-semibold cursor-pointer transition-colors duration-150"
                routerLinkActive="!border-primary-500"
                [routerLink]="item.routerLink"
                [routerLinkActiveOptions]="{ exact: true }"
                (click)="handleMenuClick(item)">
                <i class="block md:!hidden" [class]="item.icon"></i>
                <span>{{ item.label }}</span>
              </a>
            </li>
          }
        } @else {
          <li>
            <a
              class="flex gap-4 px-6 py-3 h-full md:py-2 items-center text-gray-600 dark:text-gray-300 border-l-2 md:border-b-2 md:border-l-0 border-transparent hover:border-primary-500 font-semibold cursor-pointer transition-colors duration-150"
              routerLink="/login"
              routerLinkActive="!border-primary-500"
              [routerLinkActiveOptions]="{ exact: true }"
              (click)="closeSidebar()">
              <i class="pi pi-sign-in"></i>
              <span>Login</span>
            </a>
          </li>
          @if (enablePublicSignup) {
            <li>
              <a
                class="flex gap-4 px-6 py-3 h-full md:py-2 items-center text-gray-600 dark:text-gray-300 border-l-2 md:border-b-2 md:border-l-0 border-transparent hover:border-primary-500 font-semibold cursor-pointer transition-colors duration-150"
                routerLink="/signup"
                routerLinkActive="!border-primary-500"
                (click)="closeSidebar()">
                <i class="pi pi-user-plus"></i>
                <span>Sign Up</span>
              </a>
            </li>
          }
        }
      </ul>

      <!-- User and Auth Actions -->
      <div class="flex-col md:flex-row items-end md:items-center gap-4 hidden md:flex">
        @if (user$ | async; as user) {
          <button
            aria-label="Go to dashboard"
            class="font-semibold"
            icon="pi pi-arrow-right"
            iconPos="right"
            label="Dashboard"
            pButton
            pRipple
            routerLink="/dashboard"
            type="button"
            [text]="true"></button>
          <p-avatar
            image="{{ user?.avatarURL || 'images/avatar.jpeg' }}"
            shape="circle"
            size="normal"
            styleClass="cursor-pointer"
            (click)="menu.toggle($event)" />
          <p-menu #menu [model]="userMenuItems" [popup]="true" />
        } @else {
          <button
            aria-label="Login"
            class="font-semibold"
            label="Login"
            pButton
            routerLink="/login"
            type="button"
            [outlined]="enablePublicSignup"
            (click)="closeSidebar()"></button>
          @if (enablePublicSignup) {
            <button
              aria-label="Sign up"
              class="font-semibold"
              label="Sign Up"
              pButton
              routerLink="/signup"
              type="button"
              (click)="closeSidebar()"></button>
          }
        }
      </div>
    </div>
  </div>
</div>
